/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Close_LabelInputs */

const en_embed_captions_close_label = /** @type {(inputs: Embed_Captions_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close dialog`)
};

const fr_embed_captions_close_label = /** @type {(inputs: Embed_Captions_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la boite de dialogue`)
};

const de_embed_captions_close_label = /** @type {(inputs: Embed_Captions_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialog schließen`)
};

const it_embed_captions_close_label = /** @type {(inputs: Embed_Captions_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi finestra di dialogo`)
};

const ru_embed_captions_close_label = /** @type {(inputs: Embed_Captions_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть диалог`)
};

const es_embed_captions_close_label = /** @type {(inputs: Embed_Captions_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar diálogo`)
};

const zh_cn2_embed_captions_close_label = /** @type {(inputs: Embed_Captions_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭对话框`)
};

const ja_embed_captions_close_label = /** @type {(inputs: Embed_Captions_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダイアログを閉じる`)
};

const hi_embed_captions_close_label = /** @type {(inputs: Embed_Captions_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद बंद करें`)
};

const pt_pt2_embed_captions_close_label = /** @type {(inputs: Embed_Captions_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar caixa de diálogo`)
};

/**
* | output |
* | --- |
* | "Close dialog" |
*
* @param {Embed_Captions_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_close_label = /** @type {((inputs?: Embed_Captions_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_close_label(inputs)
	if (locale === "de") return de_embed_captions_close_label(inputs)
	if (locale === "it") return it_embed_captions_close_label(inputs)
	if (locale === "ru") return ru_embed_captions_close_label(inputs)
	if (locale === "es") return es_embed_captions_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_close_label(inputs)
	if (locale === "ja") return ja_embed_captions_close_label(inputs)
	if (locale === "hi") return hi_embed_captions_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_close_label(inputs)
	return en_embed_captions_close_label(inputs)
});